import React from 'react';
import { Box, Spinner } from '@chakra-ui/react';

const CenteredSpinner = ({ color = 'blackAlpha', label = 'Loading...' }) => (
  <div className="leaflet-center leaflet-v-center">
    <Box
      className="leaflet-control"
      pos="absolute"
      zIndex="docked"
      top="0"
      bottom="0"
      left="0"
      right="0"
      d="block"
    >
      <Spinner size="xl" ml="-4" thickness="5px" speed="0.65s" color={color} label={label} />
    </Box>
  </div>
);

export default CenteredSpinner;
